import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';

export function catalogFormFields(translate: TranslateService): FormlyFieldConfig[] {
  return [
    {
      key: 'name',
      type: 'input',
      className: 'mb-2 block',
      props: {
        label: translate.instant('CATALOG.INTERNAL_NAME'),
        required: true,
      },
    },
    {
      key: 'title',
      type: 'input',
      className: 'mb-2 block',
      props: {
        label: translate.instant('CATALOG.TITLE'),
        required: true,
      },
    },
    {
      key: 'connector',
      type: 'input',
      className: 'mb-2 block',
      props: {
        label: translate.instant('CATALOG.CONNECTOR'),
        required: true,
      },
    },
    {
      key: 'privateKey',
      type: 'input',
      className: 'mb-2 block',
      props: {
        label: translate.instant('CATALOG.PRIVATE_KEY'),
        required: true,
      },
    },
    {
      key: 'extraFields',
      type: 'repeat',
      props: {
        addText: 'Añadir campo extra',
      },
      fieldArray: {
        fieldGroup: [
          {
            key: 'key',
            type: 'input',
            className: 'flex-1',
            props: { label: 'Clave', required: true },
          },
          {
            key: 'value',
            type: 'input',
            className: 'flex-1',
            props: { label: 'Valor', required: true },
          },
        ],
      },
    },
  ];
}
